export default{
    methods: {
        emitSelection(name, metadata){
            this.$emit(name, {index: metadata.index});
        }
    }
};